import axios from 'axios'
import type {
  CountResponse,
  InsistenceCreateRequest,
  InsistenceFilters,
  InsistenceImportRequest,
  InsistenceImportResponse,
  InsistenceListRequest,
  InsistenceListResponse,
  InsistenceMeanDelayByInsuranceCompanyItem,
  InsistenceMeanDelayByInsuranceCompanyRequest,
  InsistencePatchRequest,
  InsistenceResponse,
} from 'types'

export const INSISTENCE_EXPORT_ENDPOINT = '/api/insistences/export'

export const insistenceCreate = (request: InsistenceCreateRequest) =>
  axios
    .post<InsistenceResponse>('/api/insistences', request)
    .then((res) => res.data)

export const insistenceList = (request: InsistenceListRequest) =>
  axios
    .get<InsistenceListResponse>('/api/insistences', { params: request })
    .then((res) => res.data)

export const insistenceCount = (filters?: InsistenceFilters) =>
  axios
    .get<CountResponse>('/api/insistences/count', { params: { filters } })
    .then((res) => res.data)

export const insistenceGet = (insistenceUuid: string) =>
  axios
    .get<InsistenceResponse>(`/api/insistences/${insistenceUuid}`)
    .then((res) => res.data)

interface InsistencePatchRequestProps {
  insistenceUuid: string
  data: InsistencePatchRequest
}

export const insistencePatch = ({
  insistenceUuid,
  data,
}: InsistencePatchRequestProps) =>
  axios
    .patch(`/api/insistences/${insistenceUuid}`, data)
    .then((res) => res.data)

export const insistenceDelete = (insistenceUuid: string) =>
  axios
    .delete<void>(`/api/insistences/${insistenceUuid}`)
    .then((res) => res.data)

export const insistenceImport = (data: InsistenceImportRequest[]) =>
  axios
    .post<InsistenceImportResponse[]>('/api/insistences/import', { data })
    .then((res) => res.data)

export const insistenceMeanDelayByInsuranceCompany = (
  request?: InsistenceMeanDelayByInsuranceCompanyRequest,
) =>
  axios
    .get<InsistenceMeanDelayByInsuranceCompanyItem[]>(
      '/api/insistences/mean-delay-by-insurance-company',
      { params: request },
    )
    .then((res) => res.data)
